import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";

class FormWakel extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const {
              W_dataWakel,
              clickOnDeleteWakel,
              edit_product,
              W_show,
              W_search
            } = value;
            const wakil = W_dataWakel.filter((el, i) => {
              if (W_search) {
                return el.Name.toString().includes(W_search);
              } else {
                return el;
              }
            }).map((user, i) => {
              return (
                <tr key={i} className=" f4">
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    {user.adress}
                  </td>
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    {W_show == true ? (
                      <NumberFormat
                        value={user.rejaDinar.toFixed(2)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"ID"}
                        className="f4"
                      />
                    ) : (
                      "*********"
                    )}
                  </td>
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    {W_show == true ? (
                      <NumberFormat
                        value={user.rejaDolar.toFixed(2)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                        className="f4"
                      />
                    ) : (
                      "*********"
                    )}
                  </td>
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    {user.phone}
                  </td>
                  <td style={{ border: "2px solid #f0ad4e" }} className="fk">
                    {user.Name}
                  </td>
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    {user.code}
                  </td>
                  <td
                    style={{ border: "2px solid #f0ad4e" }}
                    className="pt-1 pb-0 "
                  >
                    <div className="row">
                      <div className="col-6">
                        <button
                          onClick={() => clickOnDeleteWakel(user._id)}
                          className="btn btn-danger btn-sm "
                        >
                          <i
                            className="fas fa-trash fa-sm"
                            aria-hidden="true"
                          ></i>
                        </button>
                      </div>
                      <div className="col-6">
                        <button
                          onClick={() => edit_product(user)}
                          className="btn btn-primary btn-sm"
                          style={{ backgroundColor: "navy" }}
                        >
                          <i className="fas fa-edit" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            });

            return (
              <div className="tableFixHead">
                <table
                  id="example"
                  className="table table-striped table-bordered text-right "
                >
                  <thead>
                    <tr
                      className="text-warning f4"
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      <th style={{ border: "2px solid #f0ad4e" }}> ناونیشان</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        ID پارەی بەردەست بە
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        $ پارەی بەردەست بە
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>مۆبایل</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>ناو</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>کۆد</th>
                      <th style={{ border: "2px solid #f0ad4e" }}></th>
                    </tr>
                  </thead>
                  <tbody>{wakil}</tbody>
                </table>
              </div>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default FormWakel;
